// @flow
import axios from 'axios'
import { reset } from 'redux-form'
import { User } from '../types'
import {
  ALERT,
  CREATE_ALERT_SUCCESS,
  CREATE_FAVORITE_SUCCESS,
  DELETE_ALERT_SUCCESS,
  DELETE_FAVORITE_SUCCESS,
  FETCH_ALERTS_SUCCESS,
  FETCH_FAVORITE_PROPERTY_SUCCESS,
  FETCH_OFFERS_SUCCESS,
  FETCH_TOURS_SUCCESS,
  RESET_FAVORITE_PROPERTIES,
  UPDATE_ALERT_SUCCESS,
  UPDATE_PROFILE_FAILURE,
  UPDATE_PROFILE_SUCCESS
} from '../constants'

export function updateUser(id: number, data: { user: User }) {
  return (dispatch: Function) =>
    axios
      .patch(`/users/${id}`, data)
      .then((response) => {
        dispatch(reset('settings'))
        dispatch({ type: UPDATE_PROFILE_SUCCESS, user: response.data })
        dispatch({
          type: ALERT,
          klass: 'success',
          message: 'Account updated',
          timeout: 4000
        })
      })
      .catch(({ errors }) => {
        dispatch({ type: UPDATE_PROFILE_FAILURE, errors })
      })
}

export function updatePassword(id: number, data: { password: string }) {
  return (dispatch: Function) =>
    axios
      .patch(`/users/${id}/password`, data)
      .then(() => {
        dispatch(reset('updatePassword'))
        dispatch({
          type: ALERT,
          klass: 'success',
          message: 'Password updated',
          timeout: 4000
        })
      })
      .catch(({ message }) => {
        dispatch({ type: ALERT, message })
      })
}

export function fetchFavoriteProperty(mlsId: number) {
  return (dispatch: Function) =>
    axios.get(`/properties/${mlsId}`).then((response) => {
      dispatch({
        type: FETCH_FAVORITE_PROPERTY_SUCCESS,
        property: response.data
      })
    })
}

export function resetFavoriteProperties() {
  return (dispatch: Function) =>
    new Promise((resolve) => {
      dispatch({ type: RESET_FAVORITE_PROPERTIES })
      resolve()
    })
}

export function createFavorite(userId: number, mlsId: number) {
  return (dispatch: Function) =>
    axios
      .post(`/users/${userId}/favorites`, { mls_id: mlsId })
      .then((response) => {
        dispatch({ type: CREATE_FAVORITE_SUCCESS, favorite: response.data })
      })
}

export function deleteFavorite(userId: number, mlsId: number) {
  return (dispatch: Function) =>
    axios.delete(`/users/${userId}/favorites/${mlsId}`).then((response) => {
      dispatch({ type: DELETE_FAVORITE_SUCCESS, favorite: response.data })
    })
}

export function fetchTours(userId: number) {
  return (dispatch: Function) =>
    axios.get(`/users/${userId}/tours`).then((response) => {
      dispatch({ type: FETCH_TOURS_SUCCESS, tours: response.data })
    })
}

export function fetchOffers(userId: number) {
  return (dispatch: Function) =>
    axios.get(`/users/${userId}/offers`).then((response) => {
      dispatch({ type: FETCH_OFFERS_SUCCESS, offers: response.data })
    })
}

export function fetchAlerts(userId: number) {
  return (dispatch: Function) =>
    axios.get(`/users/${userId}/alerts`).then((response) => {
      dispatch({ type: FETCH_ALERTS_SUCCESS, alerts: response.data })
    })
}

export function createAlert(
  userId: number,
  data: {
    alert: {
      keyword: string,
      minprice: number,
      maxprice: number,
      minbeds: number,
      minbaths: number,
      minarea: number
    }
  }
) {
  return (dispatch: Function) =>
    axios
      .post(`/users/${userId}/alerts`, data)
      .then((response) => {
        dispatch({ type: CREATE_ALERT_SUCCESS, alert: response.data })
        dispatch({
          type: ALERT,
          klass: 'success',
          message: 'Saved',
          timeout: 4000
        })
      })
      .catch(({ message }) => {
        dispatch({ type: ALERT, message, timeout: 4000 })
      })
}

export function updateAlert(
  userId: number,
  alertId: number,
  data: {
    alert: {
      keyword: string,
      minprice: number,
      maxprice: number,
      minbeds: number,
      minbaths: number,
      minarea: number
    }
  }
) {
  return (dispatch: Function) =>
    axios
      .patch(`/users/${userId}/alerts/${alertId}`, data)
      .then((response) => {
        dispatch({ type: UPDATE_ALERT_SUCCESS, alert: response.data })
        dispatch({
          type: ALERT,
          klass: 'success',
          message: 'Saved',
          timeout: 4000
        })
      })
      .catch(({ message }) => {
        dispatch({ type: ALERT, message, timeout: 4000 })
      })
}

export function deleteAlert(userId: number, alertId: number) {
  return (dispatch: Function) =>
    axios.delete(`/users/${userId}/alerts/${alertId}`).then((response) => {
      dispatch({ type: DELETE_ALERT_SUCCESS, alert: response.data })
    })
}



// WEBPACK FOOTER //
// ./src/actions/user.js